import { createContext, useContext, useState } from 'react'
import { ConfirmarDialog, AlertDialog } from '../dialogs'

export const AlertContext = createContext()

export const AlertProvider = props => {
    const [confirmOpen, setConfirmOpen] = useState(false)
    const [confirmMessage, setConfirmMessage] = useState('')
    const [confirmCallback, setConfirmCallback] = useState(null)

    const [alertOpen, setAlertOpen] = useState(false)
    const [alertTitle, setAlertTitle] = useState('')
    const [alertMessage, setAlertMessage] = useState('')

    const setAlertSimple = (title, subtitle, message) => {
        const msg = [subtitle, message].filter(Boolean).join(' - ') || title
        setAlertMessage(msg)
        setAlertTitle(title || 'Atención')
        setAlertOpen(true)
    }

    const setConfirm = (title, message, cb) => {
        const msg = message || title
        setConfirmMessage(msg)
        setConfirmOpen(true)
        setConfirmCallback(() => cb)
    }

    const provider = {
        setAlertSimple,
        setConfirm
    }

    return (
        <>
            <ConfirmarDialog
                open={confirmOpen}
                handleClose={() => setConfirmOpen(false)}
                message={confirmMessage}
                select={() => {
                    if (confirmCallback) confirmCallback()
                    setConfirmOpen(false)
                }}
            />
            <AlertDialog
                open={alertOpen}
                title={alertTitle}
                message={alertMessage}
                onClose={() => setAlertOpen(false)}
                actions={[
                    {
                        text: 'Aceptar',
                        handler: () => setAlertOpen(false),
                        props: { variant: 'contained', color: 'primary' }
                    }
                ]}
            />
            <AlertContext.Provider value={provider} {...props} />
        </>
    )
}

export const useAlertContext = () => useContext(AlertContext)
